module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"modal":{"titulo":"Seleccione el pago a realizar","description":"Se encontraron múltiples pagos referenciados para este número de documento, por favor seleccione el pago que desea realizar","cerrar":"Cancelar","aceptar":"Aceptar"}}}')
  delete Component.options._Ctor
}
